module.exports = __webpack_public_path__ + "static/media/09.20a7389e.jpg";